import { createIdleLogout } from "@/hooks/createIdleLogout";
import { usePatientAuthStore } from "@/stores/patientAuthStore";

export const useIdleLogout = createIdleLogout(usePatientAuthStore, "/patient/auth/signin");
